import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LogbookService} from '../../../../../services/logbook.service';
import {EmployeeService} from '../../../../../employee.service';
import {ExternalStaffService} from '../../../../../services/external-staff.service';
import {FirebaseStorageService} from '../../../../../services/firebase-storage.service';
import * as moment from 'moment';
import {finalize} from 'rxjs/operators';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {AuthorizationService} from '../../../../../services/authorization.service';
import { NbDialogService } from '@nebular/theme';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { LogbooksAuthorizationComponentComponent } from '../../../../../authorizations/logbooks-authorization-module/logbooks-authorization-component/logbooks-authorization-component.component';
import { NewEmployeeComponent } from '../../../../../new-employee/new-employee.component';

@Component({
  selector: 'ngx-dangerous-residues-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditDangerousResiduesComponent implements OnInit {
loading: boolean = false;
  @Input() stationId: string;
  @Input() logbook: any;
  @Output() refreshLogbook: EventEmitter<any> = new EventEmitter();
  imageBase64: any = '';
  employees = [];
  images = [];
  readyData: boolean = false;
  uploads = [];
  downloadURLs = [];
  externalStaff = [];
  externalStaffStorage = [];
  externalStaffManagement = [];
  authorizations = [];
  uploadPercent: any;

  constructor(
    private logbookService: LogbookService,
    private employeeService: EmployeeService,
    private externalStaffService: ExternalStaffService,
    private firebaseStorageService: FirebaseStorageService,
    private authorizationService: AuthorizationService,
    private dialogService: NbDialogService,
    private ng2ImgMax: Ng2ImgMaxService,
  ) {
  }

  async ngOnInit() {
    console.log(this.logbook)
    await this.getEmployees();
    await this.getExternalStaffStation();
    await this.getAuthorizations();
    await this.logbook.id;
    /* this.logbook.fields.departure_date = new Date(this.logbook.fields.departure_date + 'T00:00:00') */
    // this.logbook.dateFormat = await moment.unix(this.logbook.date._seconds).format('ll');
    this.logbook.fields = await typeof this.logbook.fields === 'object' ? this.logbook.fields : JSON.parse(this.logbook.fields);
    this.readyData = true;
    await this.formatData();
    await this.getExternalStaffStation();
    await this.validateExternalStaff();
  }


  async getAuthorizations() {
    this.loading = true;
    const [err, response]: any = await this.authorizationService.index(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops,', 'error', 'Intenta más tarde [Error. Lista de Autorizaciones]');
    this.authorizations = response.data;
  }

  loadImage(evt: any, key: number) {
    if (!evt.target.files.length) return;
    const reader = new FileReader();
    this.loading = true;
    this.ng2ImgMax.resizeImage(evt.target.files[0], 1280, 720).subscribe(
      async (result) => {
        await reader.readAsDataURL(result);
        reader.onload = async (e: any) => this.images[key].imgBase64 = e.target.result;
        this.images[key].file = result;
        this.loading = false;
      },
      () => {
        this.loading = false;
        return this.alert('Oops, intenta más tarde', 'error', 'Error al intentar cargar la imagen');
      },
    );
  }

  async getExternalStaffStation() {
    this.loading = true;
    const [err, response]: any = await this.externalStaffService.getExternalStaffStation(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista proveedores]', 'error');
    this.externalStaff = response.data;
    this.externalStaffStorage = response.data;
    this.externalStaffManagement = response.data;
  }

  async getEmployees() {
    this.loading = true;
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }

  async pushImage(evt: any) {
    if (!evt.target.files.length) return;
    this.loading = true;
    for await (const image of evt.target.files) {
      const reader = new FileReader();
      if (image.type.includes("jpeg") || image.type.includes("jpg") || image.type.includes("png")) {
        this.ng2ImgMax.resizeImage(image, 1280, 720).subscribe(
          async (result) => {
            await reader.readAsDataURL(result);
            reader.onload = async (e: any) => this.images.push({ original: e.target.result, file: result });
            this.loading = false;
          },
          () => {
            this.loading = false;
            return this.alert('Oops, intenta más tarde', 'error', 'Error al intentar cargar la imagen');
          },
        );
      } else {
        this.images.push({
          original: 'https://freeiconshop.com/wp-content/uploads/edd/document-download-flat.png',
          file: image
        });
        this.loading = false;
      }
    }
  }

  async formatData() {
    if (!this.logbook.image) return;
    this.images.push({ original: this.logbook.image, originalPath: this.logbook.originalImage });

    if (!this.logbook.hasOwnProperty('others_images')) return;
    for (const image of this.logbook.others_images) {
      this.images.push({ original: image.url, originalPath: image.originalPath })
    };
    console.log(this.images);
  }

  openModal(isEdit = false) {
    this.dialogService.open(LogbooksAuthorizationComponentComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getAuthorizations() : console.error('no modificaron nada'));
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  validateForm() {
    this.store()
  }

  async store() {
    // this.logbook.date = new Date(moment(this.logbook.dateFormat).format('YYYY/MM/DD'));
    this.uploads = [];
    this.downloadURLs = [];
    this.loading = true;
    this.logbook.date = moment(this.logbook.date).format('YYYY-MM-DD');
    this.logbook.fields.departure_date = moment(this.logbook.fields.departure_date).format('YYYY-MM-DD');
    const [errUpdate] = await this.logbookService.update(this.logbook.id, this.logbook);
    if (errUpdate) {
      this.loading = false;
      return this.alert('Oops, ocurrio intentalo mas tarde', 'error');
    }
    await this.validateChangeInImages();
    if (this.images.length !== this.downloadURLs.length) {
      await this.firebaseStorageService.setPath('images/logbooks');
      for await (const [index, image] of this.images.entries()) {
        if (image.file !== undefined) {
          const extension = image.file.name.split('.')[1];
          const filename = `${this.logbook.id}_${index}.${extension}`;
          const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
          const task = this.firebaseStorageService.taskCloudStorage(filename, image.file);
          // observe percentage changes
          this.uploadPercent = task.percentageChanges();
          // get notified when the download URL is available
          task.snapshotChanges().pipe(
            finalize(() => {
              fileRef.getDownloadURL().subscribe(async (url) => {
                this.downloadURLs = this.downloadURLs.concat([url]);
                if (this.images.length === this.downloadURLs.length) {
                  const firstURL = this.downloadURLs[0];
                  this.downloadURLs.shift();
                  const [err] = await this.logbookService.updateUrlImage(this.logbook.id, firstURL, this.downloadURLs);
                  this.loading = false;
                  if (err) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
                  this.refreshLogbook.emit(true);
                  this.logbookService.exitEditLogbook()
                  this.alert('Bitácora creada con éxito', 'success');
                }
              });
            }),
          ).subscribe();
        }
      }
    } else {
      const firstURL = this.downloadURLs[0] || '';
      this.downloadURLs.shift();
      await this.updateImageUrl(firstURL, this.downloadURLs || []);
      this.loading = false;
    }
  }

  async validateChangeInImages() {
    for await (const image of this.images) {
      if (image.file === undefined) {
        await this.downloadURLs.push(image.originalPath)
      }
    }
  }

  async updateImageUrl(url: string = '', othersImages: any = []) {
    const [err] = await this.logbookService.updateUrlImage(this.logbook.id, url, othersImages);
    if (err) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
    this.refreshLogbook.emit(true);
    this.logbookService.exitEditLogbook()
    return this.alert('Bitácora editada con éxito', 'success');
  }

  async delete(index: number) {
    this.images.splice(index, 1);
  }

  async dismiss(index: number) {
    delete this.images[index].file;
    delete this.images[index].imgBase64;
  }

  async validateExternalStaff(type = 1) {
    if (this.logbook.responsable !== 'otro') {
      this.logbook.external_staff = {
        provider: '',
        responsable: '',
      };
      return;
    } else if (!this.logbook.external_staff.provider) {
      this.logbook.external_staff = {
        provider: '',
        responsable: '',
      };
    }

    if (this.logbook.fields.responsable_storage !== 'otro') {
      this.logbook.fields.external_staff_storage = {
        provider: '',
        responsable: '',
      };
      return;
    } else if (!this.logbook.external_staff_storage.provider) {
      this.logbook.external_staff_storage = {
        provider: '',
        responsable: '',
      };
    }

    if (this.logbook.fields.responsable_management !== 'otro') {
      this.logbook.external_staff = {
        provider: '',
        responsable: '',
      };
      return;
    } else if (!this.logbook.external_staff.provider) {
      this.logbook.external_staff_management = {
        provider: '',
        responsable: '',
      };
    }
  }


  async alert(title: string = '', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
